// extracted by mini-css-extract-plugin
module.exports = {"buttonHolder":"SpeakerSettings_buttonHolder__y8w_3","speakerSettingsHolder":"SpeakerSettings_speakerSettingsHolder__1QwFP"};